import { render, staticRenderFns } from "./TableCupones.vue?vue&type=template&id=21859ca3&"
import script from "./TableCupones.vue?vue&type=script&lang=js&"
export * from "./TableCupones.vue?vue&type=script&lang=js&"
import style0 from "./TableCupones.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports